module.exports = __webpack_public_path__ + "static/media/B1.347ed4ca.jpg";